export const brandLogo = {
  src: '/assets/logo/crumbs-wordmark.png',
  alt: 'Crumbs',
};

export const steps = [
  {
    number: '01',
    icon: 'calendar',
    title: 'Collect crumbs during the week',
    text: 'Add photos, notes, and little moments as you go.',
  },
  {
    number: '02',
    icon: 'upload',
    title: 'Share your week on Sunday',
    text: 'Dump your crumbs. It becomes your weekly dump.',
  },
  {
    number: '03',
    icon: 'heart',
    title: 'Stay close through it all',
    text: 'Your people react, comment, and stay in the loop.',
  },
];

export const features = [
  {
    title: 'Private circles',
    text: "Share only with the people who matter. You're in control of every circle.",
    icon: 'lock',
    accent: 'violet',
    phone: 'circles',
  },
  {
    title: 'Dumps on Sunday',
    text: "One simple dump each week. That's how the connection stays easy and meaningful.",
    icon: 'calendar',
    accent: 'pink',
    phone: 'add',
  },
  {
    title: 'Friendship archive',
    text: 'Look back on weeks together. Real memories build a lasting story.',
    icon: 'folder',
    accent: 'gold',
    phone: 'comments',
  },
];

export const phoneMockups = {
  add: {
    src: '/assets/mockups/add-crumbs.png',
    alt: 'Add Crumbs app screen with a weekly upload area and a saved mountain memory.',
  },
  comments: {
    src: '/assets/mockups/comments.png',
    alt: 'My Girls app screen with comments on a shared weekly memory.',
  },
  commentsLarge: {
    src: '/assets/mockups/comments-large.png',
    alt: 'Large comments screen showing reactions from Anna, Sarah, and Elena.',
  },
  circles: {
    src: '/assets/ui/deep-purple-pill.png',
    alt: 'Your Circles app screen with the My Girls circle selected.',
  },
  circlesLarge: {
    src: '/assets/mockups/circles-large.png',
    alt: 'Large Your Circles app screen showing circle cards and members.',
  },
  feed: {
    src: '/assets/mockups/feed.png',
    alt: 'My Girls app screen with weekly photo crumb cards from Anna and Sarah.',
  },
  share: {
    src: '/assets/mockups/share-with.png',
    alt: 'Share With app screen for choosing which circles see the week.',
  },
};

export const heroMockups = [
  { phone: 'feed', tilt: 'left' },
  { phone: 'add', tilt: 'right' },
];

export const highlightMockups = [
  { phone: 'comments', tilt: 'left' },
  { phone: 'share', tilt: 'right' },
];
